import {
  showProfile as showProfileApi,
  updatePersonalInfo as updatePersonalInfoApi,
  showMedicalRecords as showMedicalRecordsApi,
  updateMedicalHistory as updateMedicalHistoryApi,
  updatePreferences as updatePreferencesApi,
  createConsent as createConsentApi,
  updateInsurance as updateInsuranceApi,
  createAuthorizedContact as createAuthorizedContactApi,
  revokeAuthorizedContact as revokeAuthorizedContactApi,
  reAuthorizeContact as reAuthorizeContactApi
} from './api'

let showProfile = () => dispatch => {
  return showProfileApi()
}

let updatePersonalInfo = (data) => dispatch => {
  return updatePersonalInfoApi(data)
}

let showMedicalRecords = () => dispatch => {
  return showMedicalRecordsApi()
}

let updateMedicalHistory = (data) => dispatch => {
  return updateMedicalHistoryApi(data)
}

let updatePreferences = (data) => dispatch => {
  return updatePreferencesApi(data)
}

let createConsent = (data) => dispatch => {
  return createConsentApi(data)
}

let updateInsurance = (data) => dispatch => {
  return updateInsuranceApi(data)
}

let createAuthorizedContact = (data) => dispatch => {
  return createAuthorizedContactApi(data)
}

let revokeAuthorizedContact = (id) => dispatch => {
  return revokeAuthorizedContactApi(id)
}

let reAuthorizeContact = (id) => dispatch => {
  return reAuthorizeContactApi(id)
}

export {
  showProfile,
  updatePersonalInfo,
  showMedicalRecords,
  updateMedicalHistory,
  updatePreferences,
  createConsent,
  updateInsurance,
  createAuthorizedContact,
  revokeAuthorizedContact,
  reAuthorizeContact
}
